/* FNDRY - PDP video rail
   Plain JS, no framework.

   Failure direction: each card is a real <video> with `controls` and a poster,
   so with this script absent the browser's own play button is the interface.
   The branded overlay is display:none until this file sets data-fvd-ready on
   the section, which means it can never be a button that does nothing.

   One play button, never two (2026-10-12): once the overlay is live this file
   takes the native controls off each video, and puts them back the moment
   playback starts, so before play only the overlay shows and after play the
   browser's own controls (pause, sound, full screen) take over. */
(function () {
  'use strict';

  var ROOT = '[data-fndry-vd]';

  function slice(list) {
    return Array.prototype.slice.call(list || []);
  }

  function Rail(root) {
    var self = this;
    this.root = root;
    this.cards = slice(root.querySelectorAll('.fndry-vd__card'));
    if (!this.cards.length) return;

    root.setAttribute('data-fvd-ready', 'true');

    this.cards.forEach(function (card) {
      var video = card.querySelector('[data-fvd-video]');
      var play = card.querySelector('[data-fvd-play]');
      if (!video || !play) return;

      /* Belt and braces for iOS: inline playback is set as a property too. */
      video.playsInline = true;
      video.setAttribute('webkit-playsinline', '');
      showOverlay(card, video);

      play.addEventListener('click', function () {
        self.stopOthers(video);
        showNative(card, video);
        var started = video.play();
        /* A rejected play() leaves nothing playing. The overlay stays gone
           and the native controls, now on, are the one play button left. */
        if (started && started.catch) {
          started.catch(function () { showNative(card, video); });
        }
      });

      /* Once it has been started the native controls own it; the overlay only
         comes back if the clip is reset to the beginning. */
      video.addEventListener('pause', function () {
        if (video.currentTime === 0 || video.ended) showOverlay(card, video);
      });
      video.addEventListener('ended', function () {
        video.currentTime = 0;
        showOverlay(card, video);
      });
      video.addEventListener('play', function () {
        self.stopOthers(video);
        showNative(card, video);
      });
    });
  }

  /* Before play: the overlay is the only play button. */
  function showOverlay(card, video) {
    card.classList.remove('is-playing');
    video.controls = false;
  }

  /* From the first tap: the browser's controls, no overlay. */
  function showNative(card, video) {
    card.classList.add('is-playing');
    video.controls = true;
  }

  /* Two clips playing at once is two soundtracks at once. */
  Rail.prototype.stopOthers = function (keep) {
    this.cards.forEach(function (card) {
      var v = card.querySelector('[data-fvd-video]');
      if (!v || v === keep) return;
      if (!v.paused) v.pause();
    });
  };

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var found = slice(context.querySelectorAll(ROOT));
    if (context.matches && context.matches(ROOT)) found.unshift(context);

    found.forEach(function (root) {
      if (root.getAttribute('data-fvd-init') === 'true') return;
      root.setAttribute('data-fvd-init', 'true');
      try {
        root.fndryVideoRail = new Rail(root);
      } catch (error) {
        /* Back to the browser's own controls. */
        root.removeAttribute('data-fvd-ready');
        if (window.console && console.error) console.error('[fndry-pdp-videos]', error);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var root = target.matches && target.matches(ROOT) ? target : target.querySelector(ROOT);
    if (root) root.removeAttribute('data-fvd-init');
  });

  /* Selecting a clip in the editor scrolls the rail to it rather than leaving
     the merchant editing something off screen. */
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block || !block.closest || !block.closest(ROOT)) return;
    var rail = block.closest('[data-fvd-rail]');
    if (!rail) return;
    var railBox = rail.getBoundingClientRect();
    var box = block.getBoundingClientRect();
    var delta = box.left - railBox.left - (railBox.width - box.width) / 2;
    rail.scrollLeft = Math.max(0, Math.min(rail.scrollLeft + delta, rail.scrollWidth - rail.clientWidth));
  });
})();
